// CMS Sidebar navigation per app kind
export const CMS_NAV_BY_KIND = {
  ecommerce:  [
    { key: "overview", label: "Overview", icon: "📊" },
    { key: "products", label: "Products", icon: "📦" },
    { key: "banners", label: "Banners", icon: "🖼" },
    { key: "orders", label: "Orders", icon: "📋" },
    { key: "customers", label: "Customers", icon: "👥" },
    { key: "reviews", label: "Reviews", icon: "⭐" },
    { key: "pages", label: "Pages", icon: "🗂" },
    { key: "media", label: "Media Library", icon: "🖼" },
    { key: "reports", label: "Reports", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙" },
  ],
  restaurant: [
    { key: "overview", label: "Overview", icon: "📊" },
    { key: "menu", label: "Menu Items", icon: "🍽" },
    { key: "banners", label: "Banners", icon: "🖼" },
    { key: "orders", label: "Orders", icon: "📋" },
    { key: "customers", label: "Customers", icon: "👥" },
    { key: "reviews", label: "Reviews", icon: "⭐" },
    { key: "pages", label: "Pages", icon: "🗂" },
    { key: "media", label: "Media Library", icon: "🖼" },
    { key: "reports", label: "Reports", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙" },
  ],
  health: [
    { key: "overview", label: "Overview", icon: "📊" },
    { key: "doctors", label: "Doctors", icon: "👨‍⚕️" },
    { key: "appointments", label: "Appointments", icon: "📅" },
    { key: "patients", label: "Patients", icon: "👥" },
    { key: "banners", label: "Banners", icon: "🖼" },
    { key: "reviews", label: "Reviews", icon: "⭐" },
    { key: "pages", label: "Pages", icon: "🗂" },
    { key: "media", label: "Media Library", icon: "🖼" },
    { key: "reports", label: "Reports", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙" },
  ],
  education: [
    { key: "overview", label: "Overview", icon: "📊" },
    { key: "courses", label: "Courses", icon: "📚" },
    { key: "instructors", label: "Instructors", icon: "👩‍🏫" },
    { key: "students", label: "Students", icon: "👥" },
    { key: "banners", label: "Banners", icon: "🖼" },
    { key: "reviews", label: "Reviews", icon: "⭐" },
    { key: "pages", label: "Pages", icon: "🗂" },
    { key: "media", label: "Media Library", icon: "🖼" },
    { key: "reports", label: "Reports", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙" },
  ],
  realestate: [
    { key: "overview", label: "Overview", icon: "📊" },
    { key: "properties", label: "Properties", icon: "🏠" },
    { key: "agents", label: "Agents", icon: "🤝" },
    { key: "leads", label: "Inquiries", icon: "📋" },
    { key: "banners", label: "Banners", icon: "🖼" },
    { key: "pages", label: "Pages", icon: "🗂" },
    { key: "media", label: "Media Library", icon: "🖼" },
    { key: "reports", label: "Reports", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙" },
  ],
  travel: [
    { key: "overview", label: "Overview", icon: "📊" },
    { key: "packages", label: "Tour Packages", icon: "✈️" },
    { key: "destinations", label: "Destinations", icon: "📍" },
    { key: "orders", label: "Bookings", icon: "📋" },
    { key: "banners", label: "Banners", icon: "🖼" },
    { key: "reviews", label: "Reviews", icon: "⭐" },
    { key: "pages", label: "Pages", icon: "🗂" },
    { key: "media", label: "Media Library", icon: "🖼" },
    { key: "reports", label: "Reports", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙" },
  ],
  ngo: [
    { key: "overview", label: "Overview", icon: "📊" },
    { key: "campaigns", label: "Campaigns", icon: "🎯" },
    { key: "team", label: "Team", icon: "👫" },
    { key: "banners", label: "Banners", icon: "🖼" },
    { key: "pages", label: "Pages", icon: "🗂" },
    { key: "media", label: "Media Library", icon: "🖼" },
    { key: "reports", label: "Reports", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙" },
  ],
  saas: [
    { key: "overview", label: "Overview", icon: "📊" },
    { key: "pricing", label: "Pricing", icon: "💰" },
    { key: "banners", label: "Banners", icon: "🖼" },
    { key: "pages", label: "Pages", icon: "🗂" },
    { key: "media", label: "Media Library", icon: "🖼" },
    { key: "reports", label: "Reports", icon: "📊" },
    { key: "settings", label: "Settings", icon: "⚙" },
  ],
};
